import "./ReportKpiCards.css";

const formatDisplay = (value) => {
  if (value == null || value === "") return "—";
  if (typeof value === "number") {
    return Number.isInteger(value)
      ? value.toLocaleString()
      : value.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
  }
  return value;
};

/**
 * Shared report KPI strip — matches Master Portal / Transactions card theme.
 * @param {{ cards: Array<{ key?: string, label: string, value: any, accent?: string, icon?: React.ReactNode, subValue?: string }>, loading?: boolean }} props
 */
const ReportKpiCards = ({ cards = [], loading = false }) => {
  const count = Math.max(cards.length, 1);

  return (
    <div
      className="report-kpi-row"
      style={{ "--report-kpi-cols": count }}
      role="list"
      aria-label="Report summary"
    >
      {cards.map((card, index) => {
        const accent = card.accent || "#22419e";
        return (
          <article
            key={card.key || card.label || index}
            className="report-kpi-card"
            role="listitem"
            style={{
              "--kpi-accent": accent,
              "--kpi-soft": `${accent}1a`,
            }}
          >
            {loading ? (
              <div className="report-kpi-loading" aria-busy="true">
                <div className="report-kpi-spinner" />
              </div>
            ) : (
              <>
                <div className="report-kpi-top">
                  <p className="report-kpi-label">{card.label}</p>
                  {card.icon ? (
                    <span className="report-kpi-icon" aria-hidden>
                      {card.icon}
                    </span>
                  ) : null}
                </div>
                <p
                  className={`report-kpi-value${
                    card.compact ? " is-compact" : ""
                  }`}
                >
                  {formatDisplay(card.value)}
                </p>
                {card.subValue != null && card.subValue !== "" ? (
                  <p className="report-kpi-sub">{card.subValue}</p>
                ) : null}
              </>
            )}
          </article>
        );
      })}
    </div>
  );
};

export default ReportKpiCards;
